import api from '../../../lib/Api'
import * as actions from './actions'
import { addNotification } from '../../notifications'

export const onFileChange = event => {
  return async function(dispatch) {
    const file = event.target.files[0]
    dispatch(actions.setSelectedFile(file))
  }
}

export const handleUpload = ({ file, createAccessTokens}) => {
  return async function(dispatch) {
    dispatch(actions.setIsSubmitting())
    const bodyFormData = new FormData()
    bodyFormData.set('rosterFile', file)
    bodyFormData.set('createAccessCodes', createAccessTokens)

    try {
      const response = await api.post('roster/rosterLicenses', bodyFormData)
      response.file = file
      dispatch(actions.setRostingSuccess(response))
    } catch (error) {
      const errorMsg =
        error.response && error.response.status === 400
          ? error.response.data
          : "Something's gone wrong while uploading file. Please try again or file a ticket for assistance."
      dispatch(actions.setRostingError(errorMsg, file))

      dispatch(
        addNotification({
          color: 'danger',
          text: errorMsg,
        }),
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/roster/operations.js